import {TFunction} from 'i18next'
import {isNumber} from 'lodash'

import {formatFloat} from '../../common/format'

export const formatFreeLimeValue = (value: number | undefined, t: TFunction, fractionDigits = 2) =>
  isNumber(value) ? `${formatFloat(value, {fractionDigits})} %` : t('common.na')
